import type { ValidationResult } from "@entrilia/shared/utilities/validators";

export type FormValidationResults<TFormKey extends PropertyKey> = Partial<Record<TFormKey, ValidationResult>>;

export const isFormValid = <TFormKey extends PropertyKey>(
  validationResults: FormValidationResults<TFormKey>
): boolean => Object.values(validationResults).every((result) => (result as ValidationResult).isValid);
